import { Helpers } from '../../helpers';
import { IBullpenStatus } from '../../interfaces/ibullpen-status';
import { ScenarioWell } from '../scenario-well';

export class BullpenStatusBase {
  BullpenStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_BullpenStatus?: Array<ScenarioWell> | null;

  constructor(item?: IBullpenStatus) {
    if (item) {

      this.BullpenStatusId = item.BullpenStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_BullpenStatus = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_BullpenStatus);
    }
  }
}